import { muiGlobalTheme } from '@/muiGlobalTheme';

export const stylesAppBar = {
  background: 'linear-gradient(180deg, rgba(246, 246, 249, 1) 75%, rgba(246, 246, 249, 0) 100%)',
  transition: muiGlobalTheme.transitions.create(['width', 'margin'], {
    easing: muiGlobalTheme.transitions.easing.sharp,
    duration: muiGlobalTheme.transitions.duration.leavingScreen,
  }),
};

export const stylesBreadcrumb = {
  flexGrow: 1,
  fontSize: 'bodySM.fontSize',
  minWidth: '200px',
};
export const stylesBreadcrumbParent = {
  fontWeight: muiGlobalTheme.typography.fontWeightMedium,
  color: muiGlobalTheme.palette.text.disabled,
};
export const stylesBreadcrumbCurrent = {
  fontWeight: muiGlobalTheme.typography.fontWeightMedium,
};
export const stylesBreadcrumbSeparator = {
  color: muiGlobalTheme.palette.text.disabled,
};

export const stylesButtonMenu = {
  mr: muiGlobalTheme.spacing(4),
  '&:focus, &:focus-visible': {
    outline: 'none',
  },
};

export const stylesAppBarAction = {
  mr: muiGlobalTheme.spacing(1),
};
